import { render, staticRenderFns } from "./ListaPacientes.vue?vue&type=template&id=210e9820&scoped=true&"
import script from "./ListaPacientes.vue?vue&type=script&lang=js&"
export * from "./ListaPacientes.vue?vue&type=script&lang=js&"
import style0 from "./ListaPacientes.vue?vue&type=style&index=0&id=210e9820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210e9820",
  null
  
)

export default component.exports